export const segmentCollectionQuery = `
    items {
        title
        seo {
            metaTitle
            metaDescription
            metaImage {
            description
            url
            }
        }
        artist {
            name
            title
            description
            profileImage {
            description
            url
            }
        }
        year
        meditationType
        artworkImage {
            description
            url(transform: {
                format: JPG_PROGRESSIVE,
                quality: 80
            })
        }
        highResolutionArtworkImage {
            description
            url(transform: {
                format: JPG_PROGRESSIVE,
            })
        }
        audio {
            length
            audioTitle
            audio {
                description
                url
            }
            author {
                name
            }
        }
        slug
        artworkDescription
        segmentContentCollection(limit: 20) {
          items {
            __typename
            ... on RichTextPanel {
              content {
                json
              }
            }
            ... on VideoPanel {
              youtubeUrl
            }
            ... on ImagePanel {
              altText
              image {
                description
                url(transform: {
                  format: JPG_PROGRESSIVE,
                  quality: 80
                })
              }
            }
            ... on AccordionPanel {
              title
              accordionItemsCollection(limit: 20) {
                items {
                  title
                  accordionContent {
                    content {
                      json
                    }
                  }
                }
              }
            }
          }
        }
    }
`;

export const galleryCollectionQuery = `
    items {
        title
        slug
        seo {
            metaTitle
            metaDescription
            metaImage {
                description
                url
            }
        }
        headerImage {
            description
            url(transform: {
                format: JPG_PROGRESSIVE,
                quality: 80
            })
        }
        subTitle
        location
        galleryContentCollection(limit: 20) {
          items {
            __typename
            ... on RichTextPanel {
              content {
                json
              }
            }
            ... on VideoPanel {
              youtubeUrl
            }
            ... on ImagePanel {
              altText
              image {
                description
                url(transform: {
                  format: JPG_PROGRESSIVE,
                  quality: 80
                })
              }
            }
            ... on AccordionPanel {
              title
              accordionItemsCollection(limit: 20) {
                items {
                  title
                  accordionContent {
                    content {
                      json
                    }
                  }
                }
              }
            }
            ... on AudioPanel {
              audio {
                author {
                  name
                }
                audio {
                  url
                  description
                }
                audioTitle
                length
              }
            }
          }
        }
        type
        primerTitle
        primerDescription
        primerAudio {
          author {
            name
          }
          audio {
            url
            description
          }
          audioTitle
          length
        }
        segmentsCollection(limit: 20) {
            items {
                title
                slug
                artworkImage {
                    description
                    url(transform: {
                        format: JPG_PROGRESSIVE,
                        quality: 80
                    })
                }
                artist {
                    name
                }
                year
                meditationType
                audio {
                    length
                author {
                    name
                }
                }
            }
        }
        authorsCollection(limit: 20) {
            items {
                title
                name
                description
                profileImage {
                    description
                    url
                }
            }
        }
    }
`;

export const homeCollectionQuery = `
    items {
        seo {
            metaTitle
            metaDescription
            metaImage {
                description
                url
            }
        }
        heading
        homeContentCollection(limit: 20) {
          items {
            __typename
            ... on RichTextPanel {
              content {
                json
              }
            }
            ... on VideoPanel {
              youtubeUrl
            }
            ... on ImagePanel {
              altText
              image {
                description
                url(transform: {
                  format: JPG_PROGRESSIVE,
                  quality: 80
                })
              }
            }
            ... on AccordionPanel {
              title
              accordionItemsCollection(limit: 20) {
                items {
                  title
                  accordionContent {
                    content {
                      json
                    }
                  }
                }
              }
            }
            ... on AudioPanel {
              audio {
                author {
                  name
                }
                audio {
                  url
                  description
                }
                audioTitle
                length
              }
            }
          }
        }
        collectionsCollection(limit: 6) {
        items {
          collectionTag
          headerImage {
            description
            url(transform: {
              format: JPG_PROGRESSIVE,
              quality: 80
          })
          }
        }
      }
    }
`;

export const collectionsCollectionQuery = `
    items {
      collectionTag
      seo {
            metaTitle
            metaDescription
            metaImage {
                description
                url
            }
        }
      headerImage {
          description
          url(transform: {
              format: JPG_PROGRESSIVE,
              quality: 80
          })
      }
      collectionContentCollection(limit: 20) {
        items {
          __typename
          ... on RichTextPanel {
            content {
              json
            }
          }
          ... on VideoPanel {
            youtubeUrl
          }
          ... on ImagePanel {
            altText
            image {
              description
              url(transform: {format: JPG_PROGRESSIVE, quality: 80})
            }
          }
          ... on AccordionPanel {
            title
            accordionItemsCollection {
              items {
                title
                accordionContent {
                  content {
                    json
                  }
                }
              }
            }
          }
          ... on AudioPanel {
              audio {
                author {
                  name
                }
                audio {
                  url
                  description
                }
                audioTitle
                length
              }
            }
        }
      }
    }
`;

export const getGalleryCollectionQuery = `
  galleryCollection(where: {tags_contains_some: [$tag]}, limit: 20) {
      items {
        title
        slug
        tags
        featured
        comingSoon
        location
        headerImage {
            url(transform: {
                format: JPG_PROGRESSIVE,
                width: 358,
                height: 540,
                resizeStrategy: FILL,
                quality: 80
            })
            description
        }
        segmentsCollection {
            total
        }
        authorsCollection {
            total
        }
      }
    }
`;

export const getHomeGalleryCollectionQuery = `
  galleryCollection {
      items {
        tags
      }
    }
`;
